import React from 'react';
import { Link } from 'react-router-dom';
import { RiDeleteBin2Fill } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromWatchlist } from '../../redux/actions/movieActions';
import './WatchList.scss';
import fullDate from '../DateFunction';

const WatchListMovie = () => {
    const infos = useSelector((state) => state.watchlistMovie.watchlist);
    const dispatch = useDispatch();

    return (
        <>
            {
                infos.filter((info, idx) => idx < infos.length).map((info) => (
                    <div className="featured-movie" key={info.id}>
                        <div className="watchlist-movie-img-container">
                            <Link to={`/movie/${info.id}`}>
                            <img src={(`https://image.tmdb.org/t/p/original${info.poster_path}`)} alt={info.title} className="watchlist-movie-img" />
                            </Link>
                        </div>
                        <div className="watchlist-movie-info">
                            <div className="feature-title-container">
                                <h2 className="feature-title">{(info.title).length < 26 ? info.title : `${(info.title).substring(0, 26)}...`}</h2>
                            </div>
                            { info.release_date &&
                                <p className="release-date">Released: {fullDate(info.release_date)}</p>
                            }
                            <div className="watchlist-movie-buttons">
                                {/* <div className="watchlist-movie-button" onClick={() => {dispatch(removeFromWatchlist(info))}}><RiDeleteBin2Fill className="watchlist-remove-icon" /> remove from watchlist</div> */}
                                <div className="watchlist-movie-button" onClick={() => {dispatch(removeFromWatchlist(info))}}><RiDeleteBin2Fill className="watchlist-remove-icon" /></div>
                            </div>            
                        </div>
                    </div>
                ))
            }
        </>
    )
};

export default WatchListMovie;